var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvionSujeto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#020C41;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30,
    y1: 16.3,
    x2: 30,
    y2: 6.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 43.8,
    y1: 22.1,
    x2: 51,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 14.5,
    x2: 16.2,
    y2: 22.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.8,41.6l-8.7,5c-3,1.7-4.9,0.6-14.3-1.4l-1.8,1l7.6,5.3l-1.5,0.9c-0.4,0.2-0.2,0.8,0.3,0.7 c11.3-1.5,16.7-3.6,16.7-3.6L51,35.1c0,0,8.6-5,5.2-6.2c-3.8-1.4-11.6,3-11.6,3l-9.6,5.5L19,31.9l-1,0.6l11.4,10.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "40.5,44.9 39.9,50.4 38.4,51.6 34.9,48.2  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvionSujeto);
export default __webpack_public_path__ + "static/media/avion-sujeto.5f7f7695475657a6ceb164782a5c7fab.svg";
export { ForwardRef as ReactComponent };